import { render, staticRenderFns } from "./pdf_display.vue?vue&type=template&id=fc063aee&scoped=true&"
import script from "./pdf_display.vue?vue&type=script&lang=js&"
export * from "./pdf_display.vue?vue&type=script&lang=js&"
import style0 from "./pdf_display.vue?vue&type=style&index=0&id=fc063aee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc063aee",
  null
  
)

export default component.exports